import BaseStore from 'customer-flows/stores/base-store'
import { tracked } from '@glimmer/tracking'
import uid from 'customer-flows/utils/uid'
import type { StripePaymentMethodType } from 'customer-flows/utils/stripe-payment-method-types'

export default class PaymentStoreClass extends BaseStore {
  @tracked hasSuccessfulPayment = false
  @tracked paymentMethod: PaymentMethod | null = null
  @tracked paymentFormIsValid = false
  @tracked selectedPaymentMethodType: StripePaymentMethodType | null = null
  @tracked paymentFormIsEmpty = true
  @tracked paymentFormIsLoading = false
  @tracked isCreatingOrder = false
  @tracked paymentErrorCode: CreateOrderFromQuoteErrorCode | null = null
  @tracked stripeFormReady = false
  @tracked stripeClientSecret: string | null = null
  @tracked idempotencyKey: string = uid()
  @tracked paymentMethodRefreshCount = 0
  @tracked availableExpressCheckoutMethods: string[] | null = null

  preOpenedKlarnaTab: Window | null = null
  klarnaCaptureConnection: EventSource | null = null

  get isDeclined() {
    return this.paymentErrorCode === 'PAYMENT_DECLINED' || this.paymentErrorCode === 'KLARNA_DECLINED'
  }
}

declare global {
  export type PaymentStore = PaymentStoreClass
  export interface StoreRegistry {
    payment: PaymentStore
  }
}
